import React, { useState, useEffect } from 'react';
import '../Styles/Carrito.css';
import { useDispatch, useSelector } from 'react-redux';
import ListedProd from './ListedProd';
import PayButton from './PayButton';
import tick from '../Icons/tick.png';
import { getTotalProductPrice } from '../Helpers/getTotalProductPrice'

const Carrito = ()=> {
    const numbersDucer = useSelector(state => state.numbersDucer)
    useEffect(()=>{
        swapValue(regionOption )
    },[])
    const swapValue = zone => {
        switch (zone){
            case 'Sabadell':{
                setTotalPrice(parseFloat(2.5))
            }
            break
            case 'SantQuirze':{
                setTotalPrice(parseFloat(3.75))
            }
            break
            case 'Barbera':{
                setTotalPrice(parseFloat(3.75))
            }
            break
            case 'Domicilio':{
                setTotalPrice(parseFloat(2.5))
            }
            break
            case 'Recoger':{
                setTotalPrice(0)
            }
        }
    }
    const middleFunction = async targetValue => {
        await setPayOption(targetValue)
        await swapValue(targetValue)
    }
    const Dispatch = useDispatch()
    const [ payOption, setPayOption ] = useState('Domicilio')
    const [ regionOption, setRegionOption ] = useState('Sabadell')
    const [ totalPrice, setTotalPrice ] = useState(0)

    const SwithcerButton = ()=>{
        if(payOption === "Recoger" && getTotalProductPrice() !== 0){
            return <PayButton link="/datospersonales" img={tick} text="Pagar"/>
        }
        else if(getTotalProductPrice() === 0){
            return <div id="Warning-container">
                <p className="Warning">No hay productos en el carrito</p>
            </div>
        }
        else{
            if((totalPrice + getTotalProductPrice()) < 15){
                return <div id="Warning-container">
                    <p className="Warning">Te faltan {(15-(totalPrice + getTotalProductPrice())).toFixed(2)} € para llegar al pedido minimo</p>
                </div>
            }
            else{
                return <PayButton link="/datospersonales" img={tick} text="Pagar" go={true} />
            }
        }
    }
    return(
        <div className="wrapperCarrito" onClick={()=>{Dispatch({type: "carrito"})}}>
            <div className="mainCarrito" onClick={e=>{e.stopPropagation()}}>
                <div className="headerCarrito">
                    <h3 className="titleCarrito">Mi Carrito</h3>
                    <button onClick={()=>{Dispatch({type: "carrito"})}}>X</button>
                </div>
                <div className="carritoContent">
                    <div className="subHeader">
                        <p>Productos</p>
                        <p>Cantidad</p>
                        <p>Total</p>
                    </div>
                    {
                        JSON.parse(localStorage.getItem("carrito")).map( producto =>{
                            return(
                                <div className="algo">
                                    <ListedProd nombre={producto.desc} cantidad={producto.cant} precio={producto.subtotal}/>
                                </div>
                            )
                        }
                        )
                    }
                    <div className="deliveryZone">
                    <div className="deliveryOptions">
                        <select name="metodoPago" id="metododePago" className="modeList" onChange={(e)=>{middleFunction(e.target.value)}}>
                            <option value="Domicilio">Domicilio</option>
                            <option value="Recoger">Recoger</option>
                        </select>
                        {
                            payOption === "Domicilio" &&
                            <div className="childCopy">
                                <p>En</p>
                                <select name="metodoPago" id="metododePago" className="modeList" onChange={(e)=>{swapValue(e.target.value)}}>
                                    <option value="Sabadell">Sabadell</option>
                                    <option value="SantQuirze">Sant Quirze</option>
                                    <option value="Barbera">Barberà</option>
                            </select>
                            </div>
                        }
                    </div>
                        <p></p>
                    <p>{totalPrice.toFixed(2)} €</p>
                    </div>
                    <div className="subTotalDiv">
                        <p>Total</p>
                    <p>{numbersDucer.totalProds}</p>
                        <p>{(totalPrice + getTotalProductPrice()).toFixed(2)} €</p>
                    </div>
                    <SwithcerButton/>
                </div>
            </div>
        </div>
    )
}

export default Carrito;